import { Token } from "@stripe/stripe-js";
import { useMutation } from "@tanstack/react-query";

import apiClient from "../apiClient";

type PayloadType = {
  email: string;
  name?: string;
  phone?: string;
  token?: Token;
};
type MutationVarsType = { pricingOptionId: string; payload: PayloadType };

/**
 * @param pricingOptionId
 * @param payload
 * @returns
 */
export const signupToFeed = async (pricingOptionId: string, payload: PayloadType) => {
  const response = await apiClient.post("/create-subscription", {
    pricingOptionId,
    name: payload.name,
    phone: payload.phone,
    email: payload.email,
    token: payload.token,
  });

  return {
    status: response.status,
    data: await response.json(),
  };
};

export const useSignupToFeedMutation = () => {
  return useMutation(async (variables: MutationVarsType) => {
    return await signupToFeed(variables.pricingOptionId, variables.payload);
  });
};
